import { cn } from '@mntn-dev/ui-utilities'
import { Button, type ButtonProps } from '../../buttons/button.tsx'
import { useFormFooterContext } from './form-footer-context.ts'

export type FormModalAcceptButtonProps = Pick<
  ButtonProps,
  | 'className'
  | 'children'
  | 'dataTestId'
  | 'dataTrackingId'
  | 'type'
  | 'onClick'
  | 'disabled'
  | 'loading'
  | 'readonly'
  | 'iconLeft'
  | 'iconRight'
>

export const FormModalAcceptButton = ({
  children,
  className,
  ...buttonProps
}: FormModalAcceptButtonProps) => {
  const { orientation } = useFormFooterContext()
  return (
    <Button
      {...buttonProps}
      variant="primary"
      size={orientation === 'vertical' ? 'lg' : 'md'}
      className={cn(
        {
          'w-full': orientation === 'vertical',
          'w-1/2': orientation === 'horizontal',
        },
        className
      )}
    >
      {children}
    </Button>
  )
}
